import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Box, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import { BaseButton } from '@alycecom/ui';
import TuneIcon from '@mui/icons-material/Tune';

const useStyles = makeStyles(({ palette, spacing }) => ({
  label: {
    justifyContent: 'center',
  },
  icon: {
    color: palette.customStyling.highlightColor,
    width: 24,
    height: 24,
    marginRight: spacing(1),
  },
  buttonText: {
    color: `${palette.customStyling.highlightColor} !important`,
    fontWeight: 'bold !important',
  },
}));

const MobileFilterButton = ({ onClick }) => {
  const classes = useStyles();
  const { palette: colors } = useTheme();
  return (
    <Box width={[120, 140]} mr={[1, 2]}>
      <BaseButton
        width="100%"
        classes={{
          label: classes.label,
        }}
        variant="outlined"
        onClick={onClick}
        color={colors.link.main}
        bgColor={colors.common.white}
        borderColor={colors.grey.regular}
      >
        <TuneIcon className={classes.icon} />
        <span className={classNames('Body-Regular-Center-Link', classes.buttonText)}>Filters</span>
      </BaseButton>
    </Box>
  );
};

MobileFilterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default memo(MobileFilterButton);
